'use client';

import Link from 'next/link';
import React from 'react';
import { ApiRoutes, Routes } from '@/settings/routes';
import { GoDotFill } from 'react-icons/go';
import { PiCalendarBlank } from 'react-icons/pi';
import { format } from 'date-fns';

export default function CardTravelGuide({ guide }) {
    if (!guide) return null;
    const dat = guide.created_at ?? guide.updated_at;
    const image = guide?.miniature ? ApiRoutes.ASSETS_ENDPOINT + guide.miniature : 'https://placehold.co/900x700';

    return (
        <div className="flex flex-col items-start gap-6">
            <div className="relative w-full min-h-[183px] flex items-end group overflow-hidden rounded">
                <span className="absolute top-0 left-0 z-10 w-full h-full bg-gray-900/30"></span>
                <img
                    src={image}
                    className="size-full max-h-[500px] top-0 start-0 object-cover content-center group-hover:scale-105 transition-transform duration-500 ease-in-out"
                    alt={guide?.title || 'Travel guide'}
                />
            </div>
            <div className="relative z-20 flex flex-col gap-4">
                <div className="flex flex-wrap items-center justify-start gap-4">
                    <ul className="flex flex-wrap items-center gap-4">
                        {(guide?.categories || []).map((category, i) => (
                            <li key={i}>
                                <Link
                                    prefetch={false}
                                    href={`${Routes.FRONT_travel_guide_category + category.slug}`}
                                    className="flex items-center gap-1 text-xs font-medium text-red-700 uppercase"
                                >
                                    <GoDotFill className="w-2 h-2" />
                                    {category.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div className="flex items-center gap-4">
                        <span className="flex items-center gap-2 text-gray-400 transition-colors">
                            <PiCalendarBlank className="w-5 h-5" />
                            {(() => {
                                const parsed = dat ? new Date(dat) : null;
                                const isValid = parsed && !isNaN(parsed.getTime());
                                return isValid ? format(parsed, 'MMMM dd, yyyy') : '';
                            })()}
                        </span>
                    </div>
                </div>
                <Link prefetch={false} href={`${Routes.FRONT_travel_guide + guide.slug}`}>
                    <h3 className="text-3xl font-semibold capitalize transition-colors default-color-title hover:text-custom-orange-900">{guide.title}</h3>
                </Link>
                <p className="custom-text-base">{guide.excerpt}</p>
                <Link
                    prefetch={false}
                    href={`${Routes.FRONT_travel_guide + guide.slug}`}
                    className='max-w-fit'
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '10px 24px',
                        borderRadius: '9999px',
                        border: 'none',
                        background: 'linear-gradient(135deg, #E8604C 0%, #313041 100%)',
                        color: '#ffffff',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        textDecoration: 'none',
                        boxShadow: '0 4px 14px rgba(232,96,76,0.35)',
                        whiteSpace: 'nowrap',
                        transition: 'box-shadow 0.25s ease, transform 0.2s ease',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 22px rgba(232,96,76,0.5)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 4px 14px rgba(232,96,76,0.35)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                    Read more
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </Link>
            </div>
        </div>
    );
}

